import React, { useEffect } from "react";
import { CoObjectItem } from "../interfaces/CoObject";
import { getAllCoObjects as loadAllDocumentObjects } from "../../utils/helpers/CustomXmlHelper";
import LoadingManager from "../../common/loading/LoadingManager";
import { SELECT_COOBJECTS_NOTIFICATION } from "../../utils/constants/notification";

export interface AllCoObjectsSelectorProps {
  documentId: string;
  children: (coObjects: CoObjectItem[]) => React.JSX.Element;
  filterPartsNotOnDB?: boolean;
}

export const AllCoObjectsSelector = (props: AllCoObjectsSelectorProps) => {
  const [coObjects, setCoObjects] = React.useState<CoObjectItem[]>(null);

  // MOVE! to this redux when we have the object lifecycle workflow
  // const dispatch = useAppDispatch();
  // const coObjects = useAppSelector(documentCoObjects);

  useEffect(() => {
    // MOVE! to this redux when we have the object lifecycle workflow
    // dispatch(loadCoObjectsAsync());
    LoadingManager.create(SELECT_COOBJECTS_NOTIFICATION);
    loadAllDocumentObjects(props.documentId, props.filterPartsNotOnDB)
      .then((loaded) => setCoObjects(loaded))
      .finally(() => {
        LoadingManager.remove(SELECT_COOBJECTS_NOTIFICATION);
      });
  }, []);

  if (coObjects) return props.children(coObjects);
  //TODO handle failures
  return null;
};
